const getImagesRoute = () => process.env.REACT_APP_IMAGES_ROUTE

export default getImagesRoute;